import { useCallback, useSyncExternalStore } from 'react';
import {
  campaignNoticeKey,
  dismissDocumentNotice,
  isDocumentNoticeDismissed,
  subscribeDocumentNotices,
} from '../document-notice-state.js';
import './DismissibleNotice.css';

export { campaignNoticeKey };

const serverSnapshot = () => false;

export function useDocumentNoticeDismissal(noticeKey, documentRef = globalThis.document) {
  const subscribe = useCallback(
    (listener) => subscribeDocumentNotices(listener, documentRef),
    [documentRef],
  );
  const snapshot = useCallback(
    () => isDocumentNoticeDismissed(noticeKey, documentRef),
    [noticeKey, documentRef],
  );
  const dismiss = useCallback(
    () => dismissDocumentNotice(noticeKey, documentRef),
    [noticeKey, documentRef],
  );
  const dismissed = useSyncExternalStore(subscribe, snapshot, serverSnapshot);
  return { dismissed, dismiss, canDismiss: Boolean(noticeKey && documentRef) };
}

export function DismissibleNotice({
  noticeKey = '',
  children,
  className = '',
  role = 'status',
  dismissLabel = 'Dismiss notice',
  'aria-labelledby': labelledBy,
}) {
  const { dismissed, dismiss, canDismiss } = useDocumentNoticeDismissal(noticeKey);
  if (dismissed) return null;
  return (
    <section className={`bl-dismissible-notice ${className}`.trim()}
      role={role} aria-labelledby={labelledBy}>
      <div className="bl-dismissible-notice-content">{children}</div>
      {canDismiss && <button type="button" className="bl-dismissible-notice-close"
        aria-label={dismissLabel} onClick={dismiss}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="m4 4 8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>}
    </section>
  );
}
